
import React from "react";
import { useState } from 'react';
import pageData from "../PageData";
const footer =()=>{ 

const [imgUrl,setImageUrl] = useState("/assets/images/usersImage/28.jpg");
const [userName, setUserName] = useState("Naveen"); 
return (
<div className="container d-print-none">
<div className="row noprint" style={{background:"cyan"}}>

<div className="col-sm-3 col-xs-3">
		
            <p className="">
                <strong>Contact Us</strong><br/>
                
                    Anil Kumar<br/>
                    Rambagh,Banglagarh<br/>
                    Darbhanga<br/>

                    Call Me - {pageData.primaryContact},<br/>{pageData.secondaryContact}
                    
                        Email:-{pageData.companyEmail}
                    
                
            </p>
			
</div> {/*col 1 end*/}
		
		<div className="col-sm-3 col-xs-3">
            <p className=""></p>
        </div> {/*col 2 end*/}
		<div className="col-sm-3 col-xs-3">
            <strong>Useful Links</strong><br/>
</div> {/*col 3 end*/}
		
        <div className="col-sm-3 col-xs-3">
            <ul className="nav nav-tabs nav-tabs">

                <li></li>
            </ul>
	    </div> {/* col 4 end*/}
</div>{ /*row 1 end*/}	
	
	<div className="row cyan noprint">
                      
                            
    
        <div className="col-sm-3">Visitors&nbsp;:&nbsp;{pageData.visitorsCount}</div>
        <div className="col-sm-6 ">
	        <strong>
		        <small>
			        &nbsp;&copy;&nbsp; Apoorva&nbsp;Traders- {pageData.currentYear},&nbsp; Developed by :{pageData.developerEmail}
			    </small>
		    </strong>
	    </div>
        <div className="col-sm-3">Updated on:{pageData.lastUpdate}</div>
    </div>
	
    
</div>



);
}
export default footer;